<template>
  <div class="layout-certificates-detail">
    <div class="container">
      <div class="header">
        <slot name="breadcrumbs"></slot>
        <div class="title s-65 font-palantino">
          <slot name="title"></slot>
        </div>
      </div>
      <!--  -->
      <div class="content" v-viewer="viewerOptions" >
        <slot name="more-photo"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      viewerOptions: {
        ref: "viewer",
        movable: false,
        rotatable: false,
        scalable: false,
        url: 'data-href',
        title: [1, (image, imageData) => `${image.alt}`]
      },
    }
  },
  components: {
    'icon-eye': () => import('@/components/icon/icon-eye.vue')
  }
}
</script>

<style lang="scss" scoped>
.layout-certificates-detail {
  padding: 3em 0;
}
.header {
  text-align: center;
}
.title {
  margin-top: 20px;
  * {
    font: inherit;
  }
}
.image {
  position: relative;
  padding-bottom: 100%;
  overflow: hidden;
  border-radius: 7px;
  * {
    cursor: zoom-in;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}
@media screen and (max-width: 767px) {
  .content {
    grid-template-columns: 1fr;
    padding: 0 15px;
  }
}
@media screen and (max-width: 767px) {
  .title {
    font-size: 36px;
  }
  .header {
    padding: 0 15px;
  }
}
</style>
